export default function useIsMobile() {
  const mobile = /iphone|ipad|ipod|android/i.test(
    navigator.userAgent.toLowerCase()
  );
  return !!mobile;
}
